<template>
  <div class="apply-page" :style="`min-height: ${height}px`">
    <div class="container-fluid">
      <div class="p-4">
        <div class="mb-5">
          <router-link to="/">
            <img src="/static/img/logo_white_new.png" alt="Indiefy" width="150" class="animated fadeIn">
          </router-link>
          <router-link to="/" class="pull-right btn btn-light text-muted animated fadeIn">
            Landing
          </router-link>
        </div>

        <div class="row justify-content-md-center">

          <div class="mt-4 px-3" v-if="page === 'main'">
            <h1 class="big-title text-white animated fadeInUp">
              {{ $t('start_application') }}
            </h1>
            <h2 class="text-white fw-bold subtitle mt-2 animated fadeInUp animation-delay-800">
              {{ $t('start_application_text') }}
            </h2>
            <div class="mt-5">
              <button type="button" class="apply-btn px-5 btn btn-primary btn-lg animated fadeInUp animation-delay-1000" @click="toggleView('personal')">
                {{ $t('apply_now') }}
              </button>
            </div>
          </div>

          <div class="mt-4 col-sm-12 col-md-4" v-show="page === 'personal'">
            <div class="card animated fadeInLeft">
              <form class="card-body" @submit.prevent="toggleView('social')" id="application-personal-form">
                <div class="clearfix mb-3">
                  <div id="progress_main" class="pull-left"></div>
                  <div class="pull-right text-right">
                    <h2 class="fw-bold mb-0">{{ $t('personal_information') }}</h2>
                    <small>{{ $t('fill_out_information') }}</small>
                  </div>
                </div>
                <div class="form-group">
                  <label for="" class="fw-bold">{{ $t('artist_name') }}</label>
                  <input type="text" v-model="artist.name" class="form-control" maxlength="40">
                </div>
                <div class="form-group">
                  <label for="" class="fw-bold">{{ $t('main_genre') }}</label>
                  <Select2 v-model="artist.main_genre" :options="genres"></Select2>
                </div>
                <div class="form-group">
                  <label for="" class="fw-bold">{{ $t('country') }}</label>
                  <Select2 v-model="artist.legal_country" :options="countries"></Select2>
                </div>
                <div class="form-group" v-if="!user.email">
                  <label for="" class="fw-bold">{{ $t('email') }}</label>
                  <input type="email" class="form-control" v-model="artist.email">
                </div>
                <div class="form-group" v-if="loaded">
                  <label for="" class="fw-bold">{{ $t('phone_number') }} <i class="ml-1 fa fa-check text-success animated zoomIn" v-if="validPhone"></i><i class="fa fa-exclamation text-warning animated zoomIn ml-1" v-if="artist.phone_number && !validPhone"></i></label>
                  <VuePhoneNumberInput @update="onUpdatePhone" v-bind:default-country-code="defaultCountry" v-model="artist.phone_number" />
                </div>
                <div class="form-group">
                  <label for=""><span class="fw-bold">{{ $t('professional_photo') }}</span> <span class="fw-normal">({{ $t('no_selfies') }})</span></label>
                  <div>
                    <croppa
                      :width="1000"
                      :height="1000"
                      :prevent-white-space="true"
                      v-model="myCroppa">
                    </croppa>
                    <div class="mt-sm">
                      <button class="btn btn-default btn-xs" type="button" @click="zoomOut()" :disabled="!hasFile">
                        <i class="fa fa-search-minus"></i>
                      </button>
                      <button class="btn btn-default btn-xs" type="button" @click="zoomIn()" :disabled="!hasFile">
                        <i class="fa fa-search-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group text-right">
                  <button type="submit" class="btn btn-primary">
                    {{ $t('continue') }}
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- <div class="mt-4 col-sm-12 col-md-4" v-show="page === 'music'">
            <div class="card animated fadeInLeft">
              <form class="card-body" @submit.prevent="toggleView('social')">
                <div class="clearfix mb-3">
                  <div id="progress_music" class="pull-left"></div>
                  <div class="pull-right text-right">
                    <h2 class="fw-bold mb-0">{{ $t('about_your_music') }}</h2>
                    <small>{{ $t('fill_out_information') }}</small>
                  </div>
                </div>

                <div class="form-group">
                  <label for="" class="fw-bold">{{ $t('how_much_invest') }}</label>
                  <select class="form-control" v-model="artist.project_type" required>
                    <option value=""></option>
                    <option value="hobby_project">{{ $t('hobby_project') }}</option>
                    <option value="life_project">{{ $t('life_project') }}</option>
                    <option value="once_month">{{ $t('once_month') }}</option>
                    <option value="more_than_month">{{ $t('more_than_month') }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="" class="fw-bold mb-0">{{ $t('describe_your_project') }}</label><br/>
                  <small>{{ $t('approval_depends_this') }}</small>
                  <textarea v-model="artist.bio" class="form-control mt-2" rows="3" required></textarea>
                </div>
                <div class="form-group text-right">
                  <button type="button" class="btn btn-light" @click="toggleView('personal')">
                    {{ $t('go_back') }}
                  </button>

                  <button type="submit" class="btn btn-primary">
                    {{ $t('continue') }}
                  </button>
                </div>
              </form>
            </div>
          </div> -->

          <div class="mt-4 col-sm-12 col-md-4" v-show="page === 'social'">
            <div class="card animated fadeInLeft">
              <form class="card-body" @submit.prevent="submit()" id="application-social-form">
                <div class="clearfix mb-3">
                  <div id="progress_social" class="pull-left"></div>
                  <div class="pull-right text-right">
                    <h2 class="fw-bold mb-0">{{ $t('social_networks') }}</h2>
                    <small>{{ $t('fill_out_information') }}</small>
                  </div>
                </div>

                <div class="form-group">
                  <p class="mb-1">
                    {{ $t('not_private_description') }}.
                  </p>
                </div>

                <div class="form-group" :class="{ 'has-error': artist.instagram && validInstagram === false }">
                  <label for="" class="fw-bold"><i class="fab fa-instagram text-warning mr-1"></i> Instagram <i class="fa fa-check text-success ml-1" v-if="artist.instagram && validInstagram === true"></i><span v-if="artist.instagram && privateProfile" class="badge badge-danger ml-1">{{ $t('private_profile') }}</span></label>
                  <input type="text" @blur="getInstagramData()" v-model="artist.instagram" class="form-control" placeholder="@indiefyapp">
                </div>
                <div class="form-group">
                  <label for="" class="fw-bold"><i class="fab fa-facebook text-primary mr-1"></i> Facebook Page</label>
                  <input type="text" v-model="artist.facebook" class="form-control" placeholder="https://facebook.com/indiefyapp">
                  <div class="text-right">
                    <small>{{ $t('page_not_personal') }}</small>
                  </div>
                </div>
                <div class="form-group">
                  <label for="" class="fw-bold"><i class="fab fa-youtube text-danger mr-1"></i> YouTube Channel</label>
                  <input type="text" v-model="artist.youtube" class="form-control" placeholder="https://youtube.com/channel/UCIb1zDHx1LGw0HB59zbmWIA">
                </div>
                <div class="form-group">
                  <label for="" class="fw-bold"><i class="fab fa-soundcloud text-warning mr-1"></i> Soundcloud</label>
                  <input type="text" v-model="artist.soundcloud" class="form-control" placeholder="https://soundcloud.com/indiefy">
                </div>
                <div class="form-group">
                  <label for="" class="fw-bold">{{ $t('do_you_have_spotify') }}</label>
                  <div class="selectgroup w-100">
                    <label class="selectgroup-item" @click="toggleSpotify(true)">
                      <input type="radio" name="value" value="yes" class="selectgroup-input">
                      <span class="selectgroup-button">{{ $t('yes') }}</span>
                    </label>
                    <label class="selectgroup-item" @click="toggleSpotify(false)">
                      <input type="radio" name="value" value="no" class="selectgroup-input" checked="">
                      <span class="selectgroup-button">{{ $t('no') }}</span>
                    </label>
                  </div>
                </div>
                <div class="form-group" v-if="showSpotify">
                  <label for="" class="fw-bold"><i class="fab fa-spotify text-success mr-1"></i> Spotify URL</label>
                  <input type="url" v-model="artist.spotify" class="form-control" placeholder="https://open.spotify.com/artist/47DPmCJZz8t7IodbxDVacZ?si=0jM4upMGTQGFiQ5f7lnJEw">
                </div>
                <div class="form-group text-right">
                  <button type="button" class="btn btn-light" @click="toggleView('music')" :disabled="saving">
                    {{ $t('go_back') }}
                  </button>
                  <button type="submit" class="btn btn-primary" :disabled="saving">
                    <span v-if="!saving">{{ $t('submit') }}</span>
                    <i class="fa fa-spinner fa-spin" v-if="saving"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div class="mt-4 col-sm-12 col-md-4" v-show="page === 'sent'">
            <div class="card animated fadeInLeft">
              <div class="card-body text-center">
                <div class="mt-2">
                  <i class="icon icon-check text-success animated zoomIn success-circle"></i>
                </div>
                <h2 class="mt-3 text-uppercase">{{ $t('thank_you') }}</h2>
                <p class="mb-2 fw-bold">
                  {{ $t('team_are_reviewing') }}
                </p>
                <p class="mb-4">
                  {{ $t('our_working_hours') }}
                </p>
                <button type="button" class="btn-access btn btn-success btn-lg mt-4 mb-3 text-uppercase" @click="toggleView('upgrade')">
                  {{ $t('get_instant_access') }}
                </button>
              </div>
            </div>
          </div>

          <div class="mt-4 col-sm-12 col-md-4" v-show="page === 'upgrade'">
            <div class="card animated fadeInLeft card-dark bg-secondary-gradient">
              <div class="card-body bubble-shadow">
                <div class="text-center">
                  <h2 class="pro-title mt-3 mb-1"><span class="text-white">Indiefy</span> <span class="text-gold">PRO</span></h2>
                  <h3 class="price text-black">
                    $<span class="price-big">4.16</span>/mo
                  </h3>
                </div>
                <ul class="list-unstyled list-features mt-4">
                  <li class="mb-2 text-gold fw-bold">
                    <i class="fa fa-circle text-success mr-2"></i> <span class="text-uppercase">{{ $t('skip_review')}}</span>
                  </li>
                  <li class="mb-2 text-white">
                    <i class="fa fa-circle text-info mr-2"></i> {{ $t('unlimited_artists') }}
                  </li>
                  <li class="mb-2 text-white">
                    <i class="fa fa-circle text-info mr-2"></i> {{ $t('express_deliveries') }}
                  </li>
                  <li class="mb-2 text-white">
                    <i class="fa fa-circle text-info mr-2"></i> {{ $t('presave_campaigns') }}
                  </li>
                  <li class="mb-2 text-white">
                    <i class="fa fa-circle text-info mr-2"></i> {{ $t('preorder') }}
                  </li>
                </ul>
                <div class="text-center mt-3 mb-3">
                  <button type="button" class="btn btn-lg btn-warning mt-3" @click="upgradeNow()">
                    {{ $t('upgrade_now') }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-4 col-sm-12 col-md-4" v-show="page === 'rejected'">
            <div class="card animated fadeInLeft">
              <div class="card-body text-center">
                <div class="mt-2">
                  <i class="fa fa-exclamation-triangle text-warning animated zoomIn success-circle"></i>
                </div>
                <h2 class="mt-3 text-uppercase">{{ $t('sorry') }}</h2>
                <p class="mb-4">
                  {{ $t('application_not_approved') }}
                </p>
                <div v-if="user.rejected_reason">
                  <b>{{ $t('possible_reasons') }}</b><br/>
                  <div v-if="user.rejected_reason === 'insufficient_social_data'">
                    <ul class="list-unstyled">
                      <li>{{ $t('incomplete_social_networks') }}</li>
                      <li>{{ $t('no_enough_social_activity') }}</li>
                      <li>{{ $t('social_not_related') }}</li>
                    </ul>
                  </div>
                  <div v-if="user.rejected_reason === 'informal_project'">
                    <ul class="list-unstyled">
                      <li>{{ $t('project_too_informal') }}</li>
                      <li>{{ $t('no_enough_social_activity') }}</li>
                      <li>{{ $t('poor_content_quality') }}</li>
                      <li>{{ $t('social_not_related') }}</li>
                    </ul>
                  </div>
                  <div v-if="user.rejected_reason === 'poor_description'">
                    <ul class="list-unstyled">
                      <li>
                        {{ $t('incomplete_bio') }}
                      </li>
                    </ul>
                  </div>
                  <div v-if="user.rejected_reason === 'bad_quality'">
                    <ul class="list-unstyled">
                      <li>
                        {{ $t('low_audio_quality') }}
                      </li>
                    </ul>
                  </div>
                </div>
                <p clas="mt-4">
                  <a v-if="user.lang !== 'es'" href="https://help.indiefy.net/hc/en-us/articles/360045769454-Why-was-my-application-rejected-" target="_blank">{{ $t('why_application_rejected') }}</a>
                  <a v-if="user.lang === 'es'" href="https://help.indiefy.net/hc/es/articles/360045769454--Porqu%C3%A9-fue-rechazada-mi-solicitud-" target="_blank">{{ $t('why_application_rejected') }}</a>
                </p>
                <div class="mt-3 mb-3">
                  <button type="button" class="btn btn-lg btn-success mt-3" @click="toggleView('upgrade')">
                    {{ $t('get_instant_access') }}
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>

    <div ref="paymentModal" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ $t('payment_method') }}</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <div v-show="!cardForm">
              <!-- <a :href="`https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=UAF38C5QC3J3L&custom=${user._id}`" class="btn btn-default btn-lg btn-block"><i class="fab fa-paypal mr-1"></i> PayPal</a> -->
              <a @click="goToPayPal()" href="javascript:void(0)" class="btn btn-default btn-lg btn-block"><i class="fab fa-paypal mr-1"></i> PayPal</a>
              <button type="button" class="btn btn-primary btn-lg btn-block" @click="showCardForm()"><i class="fa fa-credit-card mr-1"></i> Credit Card</button>
            </div>
            <div v-show="cardForm">
              <input type="text" v-model="name" class="form-control mb-2" :placeholder="$t('cardholder_name')">
              <input type="text" v-model="address" class="form-control mb-2" :placeholder="$t('billing_address')">
              <input type="text" v-if="!user.email" v-model="email" class="form-control mb-2" :placeholder="$t('email')">
              <div ref="card"></div>
              <div class="clearfix mt-1">
                <div class="pull-right mt--1">
                  <img src="/static/img/upgrade/powered_by_stripe.png" alt="" width="70">
                </div>
                <button type="button" class="btn btn-success pull-left" @click="pay()" :disabled="subscribing">
                  <i v-if="subscribing" class="fa fa-spinner fa-spin"></i>
                  <span v-if="!subscribing">{{ $t('upgrade_now') }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'
import moment from 'moment'
import VuePhoneNumberInput from 'vue-phone-number-input'
import Select2 from './utils/Select2'
import genres from '../data/genres'
import countries from '../data/countries'
import Artists from '../services/artists'
import Upload from '../services/upload'
import User from '../services/user'

export default {
  name: 'Apply',
  data () {
    return {
      // paypalUrl: 'https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=52QYE5HYU28QQ&custom=',
      paypalUrl: 'https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=X5AZSULNA6YPG&custom=',
      validInstagram: null,
      validFacebook: null,
      privateProfile: false,
      loaded: false,
      email: '',
      plan: 'monthly',
      card: null,
      stripe: null,
      name: '',
      address: '',
      subscribing: false,
      cardForm: false,
      myCroppa: null,
      saving: false,
      lang: '',
      showSpotify: false,
      validPhone: false,
      genres: _.map(genres, (genre, key) => { return key }),
      countries: _.map(countries, (country) => { return { text: country.name, id: country.name } }),
      defaultCountry: 'US',
      artist: {
        phone_number: ''
      },
      user: {},
      page: 'personal',
      height: 0
    }
  },
  computed: {
    hasFile: function () {
      return this.myCroppa && this.myCroppa.getChosenFile && this.myCroppa.getChosenFile()
    }
  },
  methods: {
    goToPayPal: function () {
      window.fbq && window.fbq('track', 'InitiateCheckout')

      setTimeout(() => {
        window.location.href = this.paypalUrl + this.user._id
      }, 500)
    },
    getFacebookData: function () {
      let artist = this.artist
      let facebookId = ''

      this.validFacebook = null

      if (artist.facebook) {
        artist.facebook = artist.facebook.trim().replace('@', '')

        if (artist.facebook.match(/^http/)) {
          facebookId = artist.facebook.split('.com/').pop().replace(/^\//, '')
        } else if (artist.facebook.match(/^facebook.com/)) {
          facebookId = artist.facebook.split('.com/').pop().replace(/^\//, '')
        } else if (artist.facebook.match(/^www.facebook.com/)) {
          facebookId = artist.facebook.split('.com/').pop().replace(/^\//, '')
        } else {
          facebookId = artist.facebook
        }

        if (facebookId) {
          User.getFacebookPage(facebookId).then(response => {
            this.validFacebook = true
          }).catch(err => {
            let error = err.response.data
            console.log('Not Found', error)

            this.validFacebook = false
          })
        } else {
          console.log('Invalid instagram url')
        }
      }
    },
    getInstagramData: function () {
      let artist = this.artist
      let instagramId = ''

      this.privateProfile = false
      this.validInstagram = null

      if (artist.instagram) {
        artist.instagram = artist.instagram.trim().replace('@', '')

        if (artist.instagram.match(/^http/)) {
          instagramId = artist.instagram.split('.com/').pop().replace(/^\//, '')
        } else if (artist.instagram.match(/^instagram.com/)) {
          instagramId = artist.instagram.split('.com/').pop().replace(/^\//, '')
        } else if (artist.instagram.match(/^www.instagram.com/)) {
          instagramId = artist.instagram.split('.com/').pop().replace(/^\//, '')
        } else {
          instagramId = artist.instagram
        }

        if (instagramId) {
          User.getInstagramUser(instagramId).then(response => {
            this.validInstagram = true
          }).catch(err => {
            let error = err.response.data
            console.log('Instagram info', error)

            if (error.name === 'private_profile') {
              this.privateProfile = true
              this.validInstagram = false
            } else {
            }
          })
        } else {
          // this.$notify({ message: this.$t('profile_not_found') }, 'warning', 'fa-exclamation')
        }
      }
    },
    pay: function () {
      window.$(this.$refs.paymentModal).modal('hide')

      window.fbq && window.fbq('track', 'InitiateCheckout')

      if (!this.name) {
        setTimeout(() => {
          window.$(this.$refs.paymentModal).modal('show')
        }, 3000)

        return this.$notify({ message: this.$t('cardholder_required') }, 'warning', 'fa-exclamation')
      }

      if (!this.address) {
        setTimeout(() => {
          window.$(this.$refs.paymentModal).modal('show')
        }, 3000)

        return this.$notify({ message: this.$t('address_required') }, 'warning', 'fa-exclamation')
      }

      if (!this.user.email && !this.email) {
        setTimeout(() => {
          window.$(this.$refs.paymentModal).modal('show')
        }, 3000)

        return this.$notify({ message: this.$t('type_email') }, 'warning', 'fa-exclamation')
      }

      this.subscribing = true
      this.stripe.createToken(this.card).then(data => {
        if (data.error) {
          this.subscribing = false

          if (data.error.code === 'incomplete_cvc') {
            this.$notify({ message: this.$t('incomplete_cvc') }, 'warning', 'fa-exclamation')
          }

          if (data.error.code === 'incomplete_zip') {
            this.$notify({ message: this.$t('incomplete_zip') }, 'warning', 'fa-exclamation')
          }

          setTimeout(() => {
            window.$(this.$refs.paymentModal).modal('show')
          }, 3000)
        } else {
          User.subscribe({ name: this.name, address: this.address, plan: this.plan, token: data.token.id }).then(response => {
            if (!response.data._id) {
              console.error(response.data)
              return this.$notify({ message: this.$t('subscribe_payment_error') }, 'warning', 'fa-exclamation')
            }

            this.subscribing = false
            location.href = '/v1/api/user/upgrading'
          }).catch(error => {
            this.subscribing = false
            console.error(error.response)

            if (error.response.code === 'card_declined') {
              this.$notify({ message: this.$t('card_declined') }, 'warning', 'fa-exclamation')
            } else {
              this.$notify({ message: this.$t('subscribe_payment_error') }, 'warning', 'fa-exclamation')
            }

            setTimeout(() => {
              window.$(this.$refs.paymentModal).modal('show')
            }, 3000)
          })
        }
      })
    },
    showCardForm: function () {
      this.cardForm = true
      this.$forceUpdate()
    },
    zoomIn: function () {
      this.myCroppa.zoomIn()
    },
    zoomOut: function () {
      this.myCroppa.zoomOut()
    },
    upgradeNow: function () {
      // this.cardForm = false
      // window.$(this.$refs.paymentModal).modal('show')
      this.stripe.redirectToCheckout({
        lineItems: [{ price: 'price_1HccB9K9qKRAJ5zqKJCo4gf0', quantity: 1 }],
        mode: 'subscription',
        successUrl: 'https://indiefy.net/v1/api/user/upgrading',
        cancelUrl: 'https://indiefy.net/upgrade?cancelled=1',
        customerEmail: this.user.email
      }).then(function (result) {
        if (result.error) {
          alert(result.error.message)
        }
      })
    },
    submit: function () {
      if (this.showSpotify && this.artist.spotify && !this.artist.spotify.match(/spotify.com\/artist\//)) {
        return this.$notify({ message: this.$t('invalid_spotify_artist_url') }, 'warning', 'fa-exclamation')
      }

      this.saving = true

      if (this.hasFile) {
        this.uploadImage(() => {
          this.submitApplication()
        })
      } else {
        this.artist.cover_image = 'https://indiefy.net/static/img/img-placeholder.jpg'
        this.artist.cover_image_small = 'https://indiefy.net/static/img/img-placeholder.jpg'
        this.submitApplication()
      }
    },
    submitApplication: function () {
      Artists.submitApplication(this.artist).then(() => {
        window.fbq && window.fbq('track', 'CompleteRegistration', { value: 0.1, currency: 'USD', content_name: 'Signup', status: 'complete' })
        window.gtag && window.gtag('event', 'conversion', {'send_to': 'AW-877256789/xNJZCP7jjbUBENXAp6ID'})
        window.twttr && window.twttr.conversion.trackPid('o2s47', { tw_sale_amount: 0, tw_order_quantity: 0 })
        window.pintrk && window.pintrk('track', 'signup')

        window.gtag && window.gtag('event', 'page_view', {
          page_title: document.title,
          page_location: 'https://indiefy.net/account-created',
          page_path: '/account-created',
          send_to: 'UA-80876238-1'
        })

        window.gtag && window.gtag('event', 'page_view', {
          page_title: document.title,
          page_location: 'https://indiefy.net/account-created',
          page_path: '/account-created',
          send_to: 'AW-877256789'
        })

        setTimeout(() => {
          this.$router.push('/dashboard')
        }, 100)
      }).catch(error => {
        let code = error.response.data

        this.saving = false
        this.page = 'sent'

        if (code && code.name === 'duplicated') {
          this.page = 'personal'
          return this.$notify({ message: this.$t('name_already_exists') }, 'warning', 'fa-exclamation')
        } else if (code && code.name) {
          this.page = 'social'
          return this.$notify({ message: this.$t(code.name) }, 'warning', 'fa-exclamation')
        }
      })
    },
    uploadImage: function (_callback) {
      this.myCroppa.generateBlob(
        blob => {
          Upload.uploadImage(blob, 'artist-images').then(response => {
            this.artist.cover_image = response.data.full
            this.artist.cover_image_small = response.data.small

            if (_callback) {
              _callback()
            }
          })
        },
        'image/jpeg',
        0.8
      ) // 80% compressed jpeg file
    },
    onUpdatePhone: function (ev) {
      this.artist.phone_code = '+' + ev.countryCallingCode

      setTimeout(() => {
        this.validPhone = window.$('.input-tel.is-valid').length
      }, 500)
    },
    toggleSpotify: function (visible) {
      this.showSpotify = visible
      this.$forceUpdate()
    },
    toggleView: function (nextPage) {
      if (nextPage === 'social') {
        if (!this.artist.name) {
          return this.$notify({ message: this.$t('name_required') }, 'warning', 'fa-exclamation')
        } else if (this.artist.name.match(/Records|Recs/gi)) {
          return this.$notify({ message: `(Records, Recs) ${this.$t('invalid_words')}` }, 'warning', 'fa-exclamation')
        }

        if (!this.artist.main_genre) {
          return this.$notify({ message: this.$t('main_genre_required') }, 'warning', 'fa-exclamation')
        }

        if (!this.artist.legal_country) {
          return this.$notify({ message: this.$t('country_required') }, 'warning', 'fa-exclamation')
        }

        if (!this.user.email && !this.artist.email) {
          return this.$notify({ message: this.$t('type_email') }, 'warning', 'fa-exclamation')
        }

        if (!this.artist.phone_number) {
          return this.$notify({ message: this.$t('please_type_valid_number') }, 'warning', 'fa-exclamation')
        } else if (this.artist.phone_number && !window.$('.input-tel.is-valid').length) {
          this.$notify({ message: this.$t('please_type_valid_number') }, 'warning', 'fa-exclamation')
          return
        }

        // if (!this.hasFile) {
        // this.$notify({ message: this.$t('please_select_photo') }, 'warning', 'fa-exclamation')
        // return
        // }
      }

      // if (nextPage === 'social') {
      //   if (!this.artist.project_type) {
      //     return this.$notify({ message: this.$t('please_select_invest_time') }, 'warning', 'fa-exclamation')
      //   }

      //   if (!this.artist.bio) {
      //     return this.$notify({ message: this.$t('please_describe_project') }, 'warning', 'fa-exclamation')
      //   }

      //   if (this.artist.bio.length < 50) {
      //     return this.$notify({ message: this.$t('description_too_short') }, 'warning', 'fa-exclamation')
      //   }
      // }

      this.page = nextPage
      this.$forceUpdate()
    },
    initProgress: function () {
      const baseConfig = {
        id: '',
        radius: 30,
        value: 1,
        maxValue: 3,
        width: 7,
        text: 1,
        colors: ['#f1f1f1', '#31CE36'],
        duration: 500,
        wrpClass: 'circles-wrp',
        textClass: 'circles-text',
        styleWrapper: true,
        styleText: true
      }

      window.Circles.create(_.defaults({ id: 'progress_main', text: '1 of 2', value: 1 }, baseConfig))
      // window.Circles.create(_.defaults({ id: 'progress_music', text: '2 of 2', value: 2 }, baseConfig))
      window.Circles.create(_.defaults({ id: 'progress_social', text: '2 of 2', value: 2 }, baseConfig))
    }
  },
  created: function () {
    this.user = this.$user
    this.lang = this.$i18n.locale

    if (!this.user._id) {
      return this.$router.push('/login?next=/dashboard')
    }

    if (this.user.verified) {
      return this.$router.push('/dashboard')
    }

    if (this.user.country) {
      let country = _.find(countries, country => country.code === this.user.country)
      this.defaultCountry = this.user.country

      if (country) {
        this.artist.legal_country = country.name
      }
    }

    if (this.user.rejected_reason && moment().diff(this.user.application_date, 'days') < 8) {
      this.page = 'rejected'
    }

    if (moment().diff(this.user.application_date, 'days') >= 7) {
      this.user.application_date = ''
    }

    this.loaded = true

    window.gtag && window.gtag('event', 'page_view', {
      page_title: document.title,
      page_location: 'https://indiefy.net/application-form',
      page_path: '/application-form',
      send_to: 'UA-80876238-1'
    })

    window.gtag && window.gtag('event', 'page_view', {
      page_title: document.title,
      page_location: 'https://indiefy.net/application-form',
      page_path: '/application-form',
      send_to: 'AW-877256789'
    })
  },
  mounted: function () {
    let stripeKey = 'pk_live_Fy0LR9SOyRoSrq4Byoj3mQtS00GjNUCMRm'

    if (window.location.href.match(/localhost|cms-development/)) {
      stripeKey = 'pk_test_WD9FBh5jNgV5uO1eFQBkLdAl000Ey6vyno'
    }

    this.stripe = window.Stripe(stripeKey)
    let elements = this.stripe.elements()
    this.card = elements.create('card')
    this.card.mount(this.$refs.card)

    this.initProgress()

    setTimeout(() => {
      this.height = window.$(window).height()
    }, 50)
  },
  components: {
    Select2,
    VuePhoneNumberInput
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.price {
  position: relative;
}

.limited-time {
  position: absolute;
  bottom: -12px;
  right: 3px;
}

.circles-valueStroke,
.circles-maxValueStroke {
  stroke-width: 5;
}

.circles-text {
  font-size: 12px !important;
}
</style>
<style lang="scss" scoped>
@media screen and (max-width:576px) {
  .container-fluid .p-4 {
    padding: 1.5rem 0 !important
  }

  .big-title {
    max-width: 80% !important;
    font-size: 3em !important;
  }

  .subtitle {
    font-size: 1.5em !important;
  }

  .btn-access {
    font-size: 14px;
  }
}

.apply-page {
  min-height: 100%;
  height: 100%;
  background-image: linear-gradient(-20deg, #B721FF 0%, #21D4FD 100%);
}

.big-title {
  max-width: 65%;
  font-size: 6em;
  font-weight: 900;
}

.subtitle {
  font-size: 2em;
}

.apply-btn {
  font-size: 1.5em;
}

.success-circle {
  font-size: 64px;
}

.pro-title {
  font-weight: 900;
  font-size: 28px;
  text-transform: uppercase;
}

.price-big {
  font-weight: 900;
  font-size: 52px;
}

.list-features {
  font-size: 16px;
}

.text-gold {
  color: #ffcd38 !important;
}

.croppa-container {
  zoom: 0.2;

  &:hover {
    background-color: #eee !important;
  }
}

.StripeElement {
  box-sizing: border-box;
  height: 40px;
  padding: 10px 12px;
  border: 1px solid #ebedf2;
  border-radius: 4px;
  background-color: white;
  margin-bottom: 10px;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.StripeElement.complete {
  border: 2px solid green;
}
</style>



// WEBPACK FOOTER //
// src/components/Apply.vue